import { customerFormatForAttachment } from "../../../../utils/customer.utils";
import QuotationListPage from "../../../QuotationList";

export default function AttachmentList({ data }) {
  const customer = data?.old ? customerFormatForAttachment(data?.old) : {};

  return (
    <QuotationListPage
      isBreadCrumbs={false}
      style={{ hasCardBg: false, pageLayoutClassName: "", contentContainerClassName: "" }}
      customer={customer}
      isCustomer={true}
    />
  );
}
